import { message } from 'antd';
import { priceDetailsActionTypes as ACTION } from '../actionTypes';

const initialState = {
  loading: false,
  loaded: false,
  message: '',
  priceDetails: {
     agentUptoTenMonthlyPrice: 0,
          agentAboveTenMonthlyPrice: 0,
          agentUptoTenAnnuallyPrice: 0,
          agentAboveTenAnnuallyPrice: 0,
          controlRoomMonthlyPrice: 0,
          controlRoomAnnuallyPrice: 0,
          simpleProcessMakingMinimumPrice: 0,
          simpleProcessMakingMaximumPrice: 0,
          complexProcessMakingMinimumPrice: 0,
          complexProcessMakingMaximumPrice: 0,
          mediumProcessMakingMinimumPrice: 0,
          mediumProcessMakingMaximumPrice: 0,
          noOfWorkingDaysInAMonth: 0,
  },
  
};

const priceDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION.PRICE_DETAILS_REQUEST:
      return { ...state, loading: true, };
    case ACTION.PRICE_DETAILS_SUCCESS:
      return { 
        ...state,
        loading: false,
        loaded: true,
        priceDetails: action.payload.priceDetails,
      };
    case ACTION.PRICE_DETAILS_FAILURE:
      return { ...state, loading: false, loaded: false, message: action.payload };
    default:
      return state;
  }
}

export default priceDetailsReducer;
